import { IconProps } from "./HomeIcon";

const LeftArrowIcon = ({ color = "#CCCCCC" }: IconProps) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Icons / medium / chevron">
        <path
          id="Vector 1"
          d="M14 7L9 12L14 17"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

export default LeftArrowIcon;
